module.exports = __webpack_public_path__ + "img/arrow-up-icon.3ac5ae2d.svg";